type ModuleName = string;

export function ExecIfDefined(module: ModuleName) {
  // eslint-disable-next-line
  return function <T>(_target: T, _propertyKey: string | symbol, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    // eslint-disable-next-line
    descriptor.value = function (...args: unknown[]) {
      if (typeof window[module as keyof typeof window] === 'undefined') {
        return;
      }
      originalMethod.apply(this, args);
    };
  };
}
